import { useMemo, useState } from 'react'
import Select from 'react-select'

import Navbar from '../../components/navbar/navbar'
import { Modable } from '../../components/Modable'

import { articles } from './articles'

import {
  ArtIcon,
  ArtInfo,
  Article,
  Container,
  Content,
  ContentModalGif,
  StyledIcon,
  Title,
} from './styles'

import * as icons from 'react-bootstrap-icons'

export function FAQ() {
  const [isOpenModalGif, setIsOpenModalGif] = useState(false)
  const [selectedArticle, setSelectedArticle] = useState()
  const [categories, setCategories] = useState([])

  function getColor(category) {
    switch (category) {
      case 'products': {
        return '#6320EE'
      }
      case 'customers': {
        return '#0072BB'
      }
      case 'orders': {
        return '#E70E02'
      }
      case 'nfes': {
        return '#5E8C61'
      }
    }
  }

  function getLabel(category) {
    switch (category) {
      case 'products': {
        return 'Produtos'
      }
      case 'customers': {
        return 'Clientes'
      }
      case 'orders': {
        return 'Pedidos'
      }
      case 'nfes': {
        return 'Notas Fiscais'
      }
    }
  }

  let articleOptions = []
  articles.forEach((article) => {
    const hasValue = articleOptions.find(
      (articleOption) => articleOption.value === article.category,
    )

    if (!hasValue) {
      articleOptions.push({
        label: getLabel(article.category),
        value: article.category,
      })
    } else {
      return
    }
  })

  function handleOpenModalGif(article) {
    setSelectedArticle(article)
    setIsOpenModalGif(true)
  }

  function handleCloseModalGif() {
    setIsOpenModalGif(false)
  }

  const Icon = ({ iconName, ...props }) => {
    const BootstrapIcon = icons[iconName]
    return <BootstrapIcon {...props} />
  }

  const filteredArticles = useMemo(() => {
    const articlesFound = []

    if (categories.length > 0) {
      for (const article of articles) {
        for (const category of categories) {
          if (article.category === category.value) {
            articlesFound.push(article)
          }
        }
      }

      return articlesFound
    } else {
      return articles
    }
  }, [categories])

  return (
    <>
      <Navbar />

      <Container className="mt-page">
        <Title>
          Zip<span>Help</span>
        </Title>

        <div
          style={{
            marginBottom: 40,
          }}
        >
          <Select
            isMulti
            value={categories}
            onChange={(values) => setCategories(values)}
            name="categories"
            options={articleOptions}
            className="basic-multi-select"
            classNamePrefix="select"
            placeholder="Selecione as categorias"
          />
        </div>

        <Content>
          {filteredArticles.map((article) => (
            <>
              <Article
                key={Math.random()}
                onClick={() => handleOpenModalGif(article)}
              >
                <ArtIcon>
                  <StyledIcon
                    style={{
                      backgroundColor: getColor(article.category),
                    }}
                  >
                    <Icon
                      iconName={article?.iconName}
                      color="white"
                      size={25}
                    />
                  </StyledIcon>
                </ArtIcon>

                <ArtInfo>
                  <h1> {article.title}</h1>
                  <p>{article.description}</p>
                </ArtInfo>
              </Article>
            </>
          ))}
        </Content>
      </Container>

      <Modable
        isOpen={isOpenModalGif}
        onClose={handleCloseModalGif}
      >
        <ContentModalGif>
          <h1>{selectedArticle?.title}</h1>
          <p>{selectedArticle?.explication()}</p>

          <video
            src={selectedArticle?.video}
            controls
          />
        </ContentModalGif>
      </Modable>
    </>
  )
}
